<template>
  <div class="outer-box" >
    <h4>Get Location Transaction Details</h4>

    <div class="inner-box" style="text-align: left; width: 600px;">

       <input class="hl_input--wrap border" :class="[istransactionIdEmpty && 'border-danger']" type="text" placeholder="Transaction ID" v-model="transactionId" />
      <p v-if="istransactionIdEmpty" class="mt-2 text-capitalize" :class="[istransactionIdEmpty && 'text-danger']">Please Enter transaction Id</p>

      <button class="btn btn-success" :class="[istransactionIdEmpty ? 'mt-0' : 'mt-5']" @click="getTransactionDetails">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Submit</span>
      </button>

      <!-- Table Start -->
      <table class="table table-bordered table-hover mt-5" v-if="response">
        <thead class="thead-dark" >
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tableData" :key="item.amount">
            <th class="text-capitalize" scope="row">{{item[0]}}</th>
            <td>{{item[1]}}</td>
          </tr>
        </tbody>
      </table>
      <!-- Table End-->

      <div v-if="response">
        <h2>Json Details</h2>
        <pre  style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>

    </div>
  </div>
</template>

<script>
import { SaasService } from "@/services";

export default {
  data() {
    return {
      transactionId: '',
      processing: false,
      response: null,
      istransactionIdEmpty:false,
      expectedTableValues: ['amount','price','markup','companyMarkup','locationId','companyId','messageId','staticPricing'],
      tableData:[],
    };
  },
  methods: {
    async getTransactionDetails(){
      try {
        if(!this.transactionId.trim().length){
          this.istransactionIdEmpty = true
          setTimeout(()=>{
            this.istransactionIdEmpty = false
          },5000)
          return
        }
        this.processing = true
        // Just empty the values,
        this.tableData = []
        this.response = null

        let { data } =  await SaasService.getLocationTransactionDetails(this.transactionId)
        this.response = data
        let { details, transaction } = data
        let resData = {...details, ...transaction }
        this.tableData = [...this.tableData,["Type",String(transaction.amount).startsWith('-') ? 'DEBIT' : 'CREDIT']]

        // Creating tabledata from json response.
        this.expectedTableValues.forEach(data => {
            Object.entries(resData).forEach(eachProperty => {
              if(data === eachProperty[0]){
                if(eachProperty[0] === 'amount' && String(eachProperty[1]).startsWith('-')){
                   this.tableData = [ ...this.tableData, [eachProperty[0], String(eachProperty[1]).split('-')[1]]]
                }else{
                  this.tableData = [ ...this.tableData, eachProperty]
                }
              }
            })
        })
        this.processing = false
      } catch (error) {
        this.response = error.message
        this.processing = false
      }
    }
  }
}

</script>

<style>
</style>
